import Sample from 'types/models/sample';
import { millisecondsToSeconds } from 'utils/unit-conversions';

/**
 * Returns the data from a flow sample formatted as volume per minute
 */
function getSampleVolumePerMinute(sample: Sample) {
  const { date, rwValue: volume, prevDate } = sample;

  const timePeriodInMilliseconds = date - prevDate;
  const timePeriodInSeconds = millisecondsToSeconds(timePeriodInMilliseconds);
  const timePeriodInMinutes = timePeriodInSeconds / 60;
  return volume / timePeriodInMinutes;
}

export default getSampleVolumePerMinute;
